import React, { useState } from 'react';
import Button from 'rsuite/Button';
import AlertPreview from './AlertPreview';
import Api from 'util/Api';

const defaultResolveFormContent = {
  comment: '',
};

const ResolveForm = ({ uiData, auth, alertData, reloadData }) => {
  const [resolveFormData, setResolveFormData] = useState({
    ...defaultResolveFormContent,
  });
  const [showResolveBlock, setShowResolveBlock] = useState(false);
  const [disabledInputs, setDisabledInputs] = useState(false);

  const openResolveBlock = () => {
    if (showResolveBlock) return;
    setShowResolveBlock(true);
  };

  const cancelResolving = () => {
    setShowResolveBlock(false);
    setResolveFormData({ ...defaultResolveFormContent });
  };

  const handleResolveFormSubmit = async (e) => {
    e.preventDefault();

    setDisabledInputs(true);

    await Api.withAuth(auth).postClearAlert(alertData.id, {
      staff_note: resolveFormData.comment,
      staff_uid: auth.currentUser.profile.email,
    });

    setDisabledInputs(false);
    reloadData();
  };

  const handleAddComment = ({ target }) => {
    let updatedData = { ...resolveFormData };
    updatedData.comment = target.value;
    setResolveFormData(updatedData);
  };

  return (
    <AlertPreview data={uiData} onClickHadler={openResolveBlock}>
      {showResolveBlock && (
        <div className='resolve-form'>
          <form onSubmit={handleResolveFormSubmit}>
            <fieldset disabled={disabledInputs}>
              <div className='textarea-wrapper'>
                <textarea
                  placeholder='Comment'
                  value={resolveFormData.comment}
                  onChange={handleAddComment}
                />
              </div>
              <div className='resolve-btns'>
                <Button size='lg' onClick={cancelResolving}>
                  Cancel
                </Button>
                <Button
                  size='lg'
                  className='resolve-btn'
                  appearance='primary'
                  type='submit'
                  disabled={!!!resolveFormData.comment.length}
                >
                  Resolve
                </Button>
              </div>
            </fieldset>
          </form>
        </div>
      )}
    </AlertPreview>
  );
};

export default ResolveForm;
